import React, { useEffect } from 'react'
import _get from 'lodash/get'
import { connect as connectRedux } from 'react-redux'
import { Map, fromJS } from 'immutable'
import { useLazyQuery } from '@apollo/client'
import {
  updateUpstreamContextFromObject,
} from '../../services/upstream-context/index'
import { getPrimary } from '../../services/languages/index'
import {
  getFormattedContentData,
  CONTENT_IMAGE_LIST,
  createTitleGroupId,
} from '../../services/content/index'
import { GET_RELATED } from '../../services/content/query'
import RowV3 from '../Row.v3/index'
import { STYLES } from '../Row.v3/utils'
import TileV2Graphql from '../Tile.v2/Tile.v2Graphql/index'
import { getPlaceholderList } from './utils'

/**
 * Detail page related tiles component
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {string} props.title - The title of the related tiles
 * @returns {JSX.Element} DetailPageV3Related
 */

function DetailPageV3Related (props) {
  const {
    detailData = Map(),
    title,
    isSeries = false,
    auth,
    user,
    upstreamContext,
  } = props

  const jwt = auth.get('jwt')
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const contentId = detailData.get('contentId')
  const contentType = detailData.get('contentType')
  const titleGroupId = detailData.get('titleGroupId') || createTitleGroupId(contentId, contentType)
  const limit = 12

  const [getRelatedData, { data, loading }] = useLazyQuery(GET_RELATED)
  const relatedData = fromJS(_get(data, ['contentList', 'content', 0, 'contentRelated'], []) || [])
  const loadingData = loading || !relatedData.size
  const placeholderList = getPlaceholderList()

  useEffect(() => {
    if (titleGroupId) {
      getRelatedData({
        variables: {
          language: userLanguage,
          titleGroupIds: [titleGroupId],
          imageType: CONTENT_IMAGE_LIST,
          limit,
        },
        context: {
          jwt,
        },
      })
    }
  }, [titleGroupId, userLanguage, jwt])

  const renderItem = (item, { index }) => {
    const tileData = getFormattedContentData(item)

    return (
      <TileV2Graphql
        key={tileData.get('contentId') || index}
        data={tileData}
        upstreamContext={updateUpstreamContextFromObject(
          upstreamContext,
          {
            contentType: tileData.get('contentType'),
            itemIndex: index,
            contentId: tileData.get('contentId'),
          },
        )}
        adminTitle="Related Videos"
        index={index}
      />
    )
  }

  const items = loadingData ? placeholderList : relatedData

  return (
    <>
      {!!title && <p className="detail-page-v3__right-rail-title">
        {title}
      </p>}
      <div className={`detail-page-v3__related ${isSeries ? 'detail-page-v3__related--series' : ''}`}>
        <RowV3
          style={isSeries ? STYLES.S12234 : STYLES.SINGLE}
          asGrid={true}
        >
          {items.map((item, index) => renderItem(item, { index }))}
        </RowV3>
      </div>
    </>
  )
}

export default connectRedux((state) => ({
  auth: state.auth,
  user: state.user,
  upstreamContext: state.upstreamContext,
}))(DetailPageV3Related)
